import { Typography } from '@mui/material';
import React from 'react';
import { Spacer } from '../../../../components';
import ModalTitleRow from './ModalTitleRow';

const ModalStepWithBack: React.FC<{
  children: React.ReactNode;
  onBack: () => void;
  onClose: () => void;
  subtitle?: string;
  subtitleAlign?: 'center' | 'left';
  title: React.ReactNode;
}> = ({ children, onBack, onClose, subtitle, subtitleAlign = 'center', title }) => {
  return (
    <>
      <ModalTitleRow onBack={onBack} onClose={onClose} title={title} />
      {subtitle ? (
        <>
          <Spacer height='xxs' />
          <Typography
            color='secondary'
            sx={{ display: 'block', width: '100%' }}
            textAlign={subtitleAlign}
            variant='p16'>
            {subtitle}
          </Typography>
          <Spacer height='sm' />
        </>
      ) : (
        <Spacer height='xs' />
      )}
      {children}
    </>
  );
};

export default ModalStepWithBack;
